import innerView from './innerView';
import outerView from './outerView';

export default {
	outer: outerView,
	inner: innerView,
};



// WEBPACK FOOTER //
// ./scripts/sky-visible/utilities/viewsProvider.js